import React  from 'react';
import './FilterModal.scss';
import PropTypes from "prop-types";

import { SuccessButton, PrimaryButton } from '../../../index';
import { WHITE } from '../../../styles/shared/colors';

const FilterModal = ({ onSaveClick, onHandleClearFilters, children }) => (
  <div className="filter-modal">
    {children}
    <SuccessButton onClick={onSaveClick}> Save </SuccessButton>
    <PrimaryButton style={{ color: WHITE }} onClick={onHandleClearFilters}> Clear filters </PrimaryButton>
  </div>
);

FilterModal.propTypes = {
  children: PropTypes.node,
  onHandleClearFilters: PropTypes.func,
  onSaveClick: PropTypes.func,
}

FilterModal.defaultProps = {
  children: null,
  onHandleClearFilters: () => {},
  onSaveClick: () => {}
}
export default FilterModal;
